export default (function() {
    if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
        return 'Proxy' in self;
    } else if (global.window) {
        return 'Proxy' in window;
    } else {
        return false
    }
})();


// WEBPACK FOOTER //
// ./src/util/hasProxy.js